module.exports = __webpack_public_path__ + "static/media/germany.508d5eb4.svg";